var _defs, _path, _ellipse, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSightseeing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#896da7;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sightseeing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.05,0A16.06,16.06,0,0,0,0,15.92C0,26.83,14.34,42.85,14.94,43.55a1.46,1.46,0,0,0,2.11,0c.6-.7,15-16.72,15-27.63A15.79,15.79,0,0,0,16.05,0Zm0,24a8.13,8.13,0,0,1-8.13-8,8.13,8.13,0,1,1,8.13,8Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 16.05,
    cy: 15.82,
    rx: 12.04,
    ry: 12.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.05,13.32a3.3,3.3,0,1,0,3.31,3.3A3.21,3.21,0,0,0,16.05,13.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.47,10.41H20.86l-.2-.9a2,2,0,0,0-2-1.6h-5a2.15,2.15,0,0,0-2,1.6l-.2.9H9.83a1.76,1.76,0,0,0-1.71,1.7v9.51a1.76,1.76,0,0,0,1.71,1.71H22.47a1.75,1.75,0,0,0,1.7-1.71V12.11A1.69,1.69,0,0,0,22.47,10.41ZM16.05,20.82a4.21,4.21,0,1,1,4.21-4.2A4.16,4.16,0,0,1,16.05,20.82Zm5.51-7.1a.37.37,0,0,1-.3.1c-.1,0-.2-.1-.3-.1s-.1-.2-.1-.3.1-.2.1-.31.2-.1.3-.1a.37.37,0,0,1,.3.1.4.4,0,0,1,.1.31C21.66,13.52,21.56,13.62,21.56,13.72Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSightseeing);
export default __webpack_public_path__ + "static/media/sightseeing.e44c124469919e6c757296a42899d66f.svg";
export { ForwardRef as ReactComponent };